<template>
  <div class="wrapper">
    <AsideMenu />
    <div id="app" :class="{ offset: $store.state.openBurgerMenu }">
      <div
        :class="{ overlay: $store.state.openBurgerMenu }"
        @click="$store.state.openBurgerMenu = false"
      ></div>
      <router-view />
    </div>
    <template v-if="$route.path !== '/'">
      <PrivilegedBar />
      <PrivilegedLogin v-if="$store.state.isOpenPrivilegedLogin" />
      <BalanceModal v-if="$store.state.balanceTarget" />
      <BulkRefund v-if="$store.state.isOpenBulkRefund" />
    </template>
  </div>
</template>

<script>
import "@/scss/_reset.scss";
import "@/scss/fonts/font.css";
import "@/scss/_main.scss";

// import Navigation from '@/components/Navigation/Navigation';
import AsideMenu from "@/components/AsideMenu/AsideMenu";
import PrivilegedBar from "@/components/privileged/PrivilegedBar";
import PrivilegedLogin from "@/components/privileged/PrivilegedLogin";
import BalanceModal from "@/components/privileged/BalanceModal";
import BulkRefund from "@/components/privileged/BulkRefund";

import { syncState, touch } from "@/utils/privileged";

const ACTIVITY_THROTTLE_MS = 10 * 1000;

export default {
  name: "App",
  components: {
    AsideMenu,
    PrivilegedBar,
    PrivilegedLogin,
    BalanceModal,
    BulkRefund
    // Navigation
  },
  methods: {
    onActivity() {
      const now = Date.now();
      if (now - (this.lastTouch || 0) < ACTIVITY_THROTTLE_MS) return;
      this.lastTouch = now;
      if (Object.values(this.$store.state.privilegedSites).some(Boolean)) touch();
    }
  },
  mounted() {
    window.addEventListener("storage", () => {
      console.log('change')
      localStorage.removeItem("bleachInfo");
      this.$store.state.isOpenExitPopup = false;
      this.$router.push("/");
    });

    syncState();
    this.syncTimer = setInterval(syncState, 30 * 1000);
    document.addEventListener("click", this.onActivity, true);
    document.addEventListener("keydown", this.onActivity, true);
  },
  beforeDestroy() {
    clearInterval(this.syncTimer);
    document.removeEventListener("click", this.onActivity, true);
    document.removeEventListener("keydown", this.onActivity, true);
  }
};
</script>
